export const datesDiffInSeconds = (startDate: Date, endDate: Date) => {
  if (startDate > endDate) console.error("The start date cannot be earlier than end date");

  const seconds = Math.floor((endDate.getTime() - startDate.getTime()) / 1000);
  const days = Math.floor(seconds / 3600 / 24);

  return { seconds, days };
};
